<script setup>
import PortalAuthShell from '@/Layouts/PortalAuthShell.vue'
</script>

<template>
  <PortalAuthShell portal="partner"><slot /></PortalAuthShell>
</template>
